import { render, staticRenderFns } from "./bak.vue?vue&type=template&id=4273f85a&scoped=true&"
import script from "./bak.vue?vue&type=script&lang=js&"
export * from "./bak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4273f85a",
  null
  
)

export default component.exports